/**
 * Account is one of the three basic building blocks of an
 * {@link AeSdk} and provides access to a signing key pair.
 */
export default class AccountBase {}
//# sourceMappingURL=Base.js.map